import { compact, getSlotCompoundVariant, memo, splitProps } from '../helpers.mjs';
import { createRecipe } from './create-recipe.mjs';

const eventCardDefaultVariants = {
  "variant": "single",
  "status": "available",
  "selected": false
}
const eventCardCompoundVariants = []

const eventCardSlotNames = [
  [
    "root",
    "eventCard__root"
  ],
  [
    "selectArea",
    "eventCard__selectArea"
  ],
  [
    "timeText",
    "eventCard__timeText"
  ],
  [
    "secondaryText",
    "eventCard__secondaryText"
  ],
  [
    "subtitle",
    "eventCard__subtitle"
  ]
]
const eventCardSlotFns = /* @__PURE__ */ eventCardSlotNames.map(([slotName, slotKey]) => [slotName, createRecipe(slotKey, eventCardDefaultVariants, getSlotCompoundVariant(eventCardCompoundVariants, slotName))])

const eventCardFn = memo((props = {}) => {
  return Object.fromEntries(eventCardSlotFns.map(([slotName, slotFn]) => [slotName, slotFn.recipeFn(props)]))
})

const eventCardVariantKeys = [
  "variant",
  "status",
  "selected"
]
const getVariantProps = (variants) => ({ ...eventCardDefaultVariants, ...compact(variants) })

export const eventCard = /* @__PURE__ */ Object.assign(eventCardFn, {
  __recipe__: false,
  __name__: 'eventCard',
  raw: (props) => props,
  classNameMap: {},
  variantKeys: eventCardVariantKeys,
  variantMap: {
  "variant": [
    "single",
    "multi"
  ],
  "status": [
    "available",
    "limited",
    "soldOut",
    "unavailable"
  ],
  "selected": [
    "true"
  ]
},
  splitVariantProps(props) {
    return splitProps(props, eventCardVariantKeys)
  },
  getVariantProps
})